import { AccessState } from './types';

export const initialState: AccessState = {
  users: [],
  page: 1,
  totalUsers: 0,
  gettingUsers: false,
  updatingUser: '',
  viewerAccess: null,
};
